import { ProfileClothingViewItem } from '../../../models/profile-clothing.model';
import { PROFILE_EMPTY_TEXT } from './view-user-profile.constants';
import { ViewUserProfileClothingMergeState } from './view-user-profile.types';

export function mergeProfileClothingItems(
  issueItems: ProfileClothingViewItem[],
  headItems: ProfileClothingViewItem[]
): ProfileClothingViewItem[] {
  var state: ViewUserProfileClothingMergeState = {
    result: [],
    headByKey: indexItems(headItems),
    usedHeadKeys: {}
  };
  appendIssueItems(state, issueItems);
  appendUnusedHeadItems(state.result, headItems, state.usedHeadKeys);
  return state.result;
}

function indexItems(items: ProfileClothingViewItem[]): {[key: string]: ProfileClothingViewItem} {
  var indexed: {[key: string]: ProfileClothingViewItem} = {};
  (items || []).forEach((item) => {
    var key = mergeKey(item);
    if (key) {
      indexed[key] = item;
    }
  });
  return indexed;
}

function appendIssueItems(state: ViewUserProfileClothingMergeState, items: ProfileClothingViewItem[]): void {
  (items || []).forEach((item) => {
    var key = mergeKey(item);
    var headItem = key ? state.headByKey[key] : null;
    if (headItem) {
      state.usedHeadKeys[key] = true;
      state.result.push(mergeItem(item, headItem));
    } else {
      state.result.push(item);
    }
  });
}

function appendUnusedHeadItems(
  result: ProfileClothingViewItem[],
  items: ProfileClothingViewItem[],
  usedHeadKeys: {[key: string]: boolean}
): void {
  (items || []).forEach((item) => {
    var key = mergeKey(item);
    if (!key || !usedHeadKeys[key]) {
      result.push(item);
    }
  });
}

function mergeItem(issueItem: ProfileClothingViewItem, headItem: ProfileClothingViewItem): ProfileClothingViewItem {
  return Object.assign(
    {},
    issueItem,
    headInventory(headItem, issueItem.positionId),
    headLifecycle(headItem),
    headActions(headItem),
    { availableRequestQuantity: issueItem.availableRequestQuantity }
  );
}

function headInventory(
  headItem: ProfileClothingViewItem,
  fallbackPositionId: string
): Partial<ProfileClothingViewItem> {
  return {
    positionId: headItem.positionId || fallbackPositionId,
    quantity: headItem.quantity,
    expiredQuantity: headItem.expiredQuantity,
    lossPendingQuantity: headItem.lossPendingQuantity,
    lostQuantity: headItem.lostQuantity,
    residualCostUsd: headItem.residualCostUsd
  };
}

function headLifecycle(headItem: ProfileClothingViewItem): Partial<ProfileClothingViewItem> {
  return {
    issueDate: headItem.issueDate,
    serviceLifeText: headItem.serviceLifeText,
    lifePercent: headItem.lifePercent,
    lifePercentText: headItem.lifePercentText,
    lifeBarClass: headItem.lifeBarClass,
    temporarilyCoveredByNoStock: headItem.temporarilyCoveredByNoStock,
    temporaryNoStockCoverageUntil: headItem.temporaryNoStockCoverageUntil,
    temporaryCoverageOnly: headItem.temporaryCoverageOnly,
    units: headItem.units || []
  };
}

function headActions(headItem: ProfileClothingViewItem): Partial<ProfileClothingViewItem> {
  return {
    canHeadExtend: headItem.canHeadExtend,
    headExtendDisabled: headItem.headExtendDisabled,
    headExtendDisabledReasonKey: headItem.headExtendDisabledReasonKey
  };
}

function mergeKey(item: ProfileClothingViewItem): string {
  return item
    ? item.catalogItemId || item.positionId || item.name || PROFILE_EMPTY_TEXT
    : PROFILE_EMPTY_TEXT;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-clothing.mapper.ts